module.exports = __webpack_public_path__ + "static/media/logoW.adeca80a.png";